import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";

import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import ReferralForm from "./ReferralForm";

import { createReferralForm } from "../../../../store/slices/referralFormsSlice";
import { fetchPatient } from "../../../../store/slices/patientsSlice";

// Helper function to convert camelCase to snake_case
const toSnakeCase = (obj) => {
    const newObj = {};
    Object.keys(obj).forEach((key) => {
        const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
        newObj[snakeKey] = obj[key];
    });
    return newObj;
};

const AddReferral = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const [formData, setFormData] = useState({
        caseId: state?.caseId || null,
        patientId: state?.patientId || null,
        date: "",
        referringFacility: "",
        patientName: "",
        dob: "",
        gender: "",
        contact: "",
        primaryComplaintDiagnosis: "",
        currentMedication: "",
        historyPreviousTreatment: "",
        furtherManagement: "",
        otherManagement: "",
        referredTo: "",
        departmentConsultant: "",
        acknowledgmentAccepted: false,
        acknowledgmentName: "",
        acknowledgmentRelation: "",
        acknowledgmentDateTime: ""
    });

    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            patientName: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                            dob: patient.dob ? patient.dob.split('T')[0] : "",
                            gender: patient.gender || "",
                            contact: patient.phone || "",
                        }));
                    }
                })
                .catch((err) => console.error("Failed to fetch patient details:", err));
        }
    }, [dispatch, patientId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Destructure the fields we need to check
            const { furtherManagement, otherManagement, ...restData } = formData;

            // Prepare data to send
            let dataToSend = { ...restData, furtherManagement };

            // Only include otherManagement if furtherManagement is "Other"
            if (furtherManagement === "Other") {
                dataToSend.otherManagement = otherManagement;
            }

            // Convert to snake_case for backend
            const payload = toSnakeCase(dataToSend);

            const res = await dispatch(createReferralForm(payload)).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "Referral Form completed successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            navigate(`/residential/optional/referral-form/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
        } catch (err) {
            Swal.fire({
                title: "Error!",
                text: err?.message || "Failed to submit Referral Form.",
                icon: "error",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <ReferralForm formData={formData} handleChange={handleChange} />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="ri-save-2-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddReferral;
